export default "__VITE_ASSET__BZCmleQ9__"